import { DistributorPricing } from "@src/api/ProductDetailApi";
import { FlatProduct } from "@src/types/product";

/**
 * Builds a short plain-text variant subheading (unit of measure / package
 * quantity) for a product. Used in place of the full product description in
 * compact contexts like order line items, where the raw description contains
 * HTML markup that does not belong in those slots.
 *
 * Mirrors the unit/quantity formatting used by VerticalProductTile so the
 * subheading reads consistently across the app (e.g. "180 Soft Gels" or
 * "Bottle 30").
 */
export const getProductVariantSubheading = (
  product: Pick<FlatProduct, "unitOfMeasure" | "packageQuantity">,
): string => {
  const unitOfMeasure = product.unitOfMeasure?.trim();
  const packageQuantity = product.packageQuantity;
  if (!unitOfMeasure) {
    return packageQuantity ? `${packageQuantity} ct` : "";
  }
  const unitHasLettersAndNumbers = /[A-Za-z].*\d|\d.*[A-Za-z]/.test(
    unitOfMeasure,
  );
  const suffix =
    !unitHasLettersAndNumbers && packageQuantity ? ` ${packageQuantity}` : "";
  return `${unitOfMeasure}${suffix}`;
};

export const getAddToCartButtonDetails = (
  livePricing: DistributorPricing | undefined,
  hasPerfectApiConnection: boolean,
) => {
  // Note: hasPerfectApiConnection means the user is connected to the distributor and the distributor API is healthy
  const isInStock = livePricing?.isInStock || false;
  const hasPrice = Boolean(livePricing?.price);
  return {
    cartButtonText: livePricing?.buttonText || "Add to Cart",
    cartButtonDisabled:
      !livePricing ||
      !hasPerfectApiConnection ||
      Boolean(livePricing?.cartButtonDisabled) ||
      !isInStock ||
      !hasPrice,
  };
};
